module.exports = "/_next/static/images/video_id_7183824747527015723-664de6054f0aa8f510019c3edaad7ab8.jpg";